import React, { memo, Dispatch, SetStateAction } from 'react';
import { Grid } from '@material-ui/core';
import { DialogDetails } from 'components/shared';
import { DashInfoCard } from 'components';
import { ISetModulocker } from 'config/interfaces';

interface DashInfoCardDetailsProps {
  info: ISetModulocker.SetBox,
  open: boolean,
  setOpen: Dispatch<SetStateAction<boolean>>,
  title: string
}

function DashInfoCardDetails({ info, open, setOpen, title }: DashInfoCardDetailsProps) {

  const Content = (
    <Grid container spacing={2}>
      <DashInfoCard name="none" elevation={3} xs={6} lg={3} xl={3} title="P" value={info.p > 0 ? info.p : '-'} fontSizeTitle="2rem" />
      <DashInfoCard name="none" elevation={3} xs={6} lg={3} xl={3} title="M" value={info.m > 0 ? info.m : '-'} fontSizeTitle="2rem" />
      <DashInfoCard name="none" elevation={3} xs={6} lg={3} xl={3} title="G" value={info.g > 0 ? info.g : '-'} fontSizeTitle="2rem" />
      <DashInfoCard name="none" elevation={3} xs={6} lg={3} xl={3} title="GG" value={info.gg > 0 ? info.gg : '-'} fontSizeTitle="2rem" />
    </Grid>
  )

  return (
    <DialogDetails
      id="dashinfocarddetails"
      title={title}
      open={open}
      setOpen={setOpen}
      content={Content}
    />
  )
}

export default memo(DashInfoCardDetails);
